/* /slice-new-components — DONE 2026-08-26
 * .agents/progress/no-item-found-page.md
 * .agents/decisions/no-item-found-page.md
 */
import { useTranslation } from 'react-i18next';
import { Navigation, navigateToMenu } from '@globalComponents/navigation';
import { useErrorPageNavStartOrder } from '@hooks/ErrorPageNav/useErrorPageNavStartOrder';
import { ERROR_PAGE_NAV_I18N } from './constants';
import { StartOrderingButton } from './StartOrderingButton';
import type { ErrorPageNavProps } from './types';

export const ErrorPageNav = ({ showStartOrdering = false, emptyBillState = false }: ErrorPageNavProps) => {
  const onStartOrdering = useErrorPageNavStartOrder();
  const { t } = useTranslation();

  return (
    <footer
      data-show-start-ordering={showStartOrdering}
      className={`error-page-nav${emptyBillState ? ' empty-bill-nav' : ''}`}
    >
      {showStartOrdering ? (
        <div>
          <StartOrderingButton
            onClick={emptyBillState ? navigateToMenu : onStartOrdering}
            label={t(ERROR_PAGE_NAV_I18N.startOrdering)}
          />
        </div>
      ) : null}
      <Navigation />
    </footer>
  );

};
